import { render } from "./dealer_reviewMore.vue?vue&type=template&id=5ea5d2ce"
import script from "./dealer_reviewMore.vue?vue&type=script&lang=js"
export * from "./dealer_reviewMore.vue?vue&type=script&lang=js"

import "./dealer_reviewMore.vue?vue&type=style&index=0&id=5ea5d2ce&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__